import { useState, useEffect } from "react";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_FIRST_PURCHASE_EVENT_STATUS,
  MARK_FIRST_PURCHASE_EVENT_SEEN,
  ISSUE_FIRST_PURCHASE_COUPON,
} from "../api/first-purchase-event";

export const useFirstPurchaseEvent = () => {
  const [hasSeenLocal, setHasSeenLocal] = useState(false);

  // 1. 상태 조회
  const { data, loading, refetch } = useQuery(GET_FIRST_PURCHASE_EVENT_STATUS, {
    fetchPolicy: "network-only", // 항상 최신 상태 조회
    onCompleted: (data) => {
      // 서버에서 eligible하지 않다고 하면 로컬 상태도 동기화할 수 있음
      // console.log("First Purchase Event Status:", data?.me?.firstPurchaseEventStatus);
    },
    onError: (error) => {
      console.error("Failed to fetch first purchase event status:", error);
    },
  });

  // 2. 봤음 처리 Mutation
  const [markSeenMutation] = useMutation(MARK_FIRST_PURCHASE_EVENT_SEEN);

  // 3. 쿠폰 발급 Mutation
  const [issueCouponMutation, { loading: isIssuing }] = useMutation(
    ISSUE_FIRST_PURCHASE_COUPON
  );

  useEffect(() => {
    // 로컬 스토리지 체크 (서버 API 응답이 오기 전 깜빡임 방지용, 혹은 중복 방지 보조)
    const alreadySeen = localStorage.getItem("has_seen_first_purchase_event");
    if (alreadySeen) {
      setHasSeenLocal(true);
    }
  }, []);

  const markAsSeen = () => {
    // 1. 로컬 상태 즉시 업데이트 (UI 반응성)
    localStorage.setItem("has_seen_first_purchase_event", "true");
    setHasSeenLocal(true);

    // 2. 서버에 전송 (백그라운드)
    markSeenMutation().catch((e) => {
      console.error("Failed to mark event as seen:", e);
    });
  };

  const issueCoupon = async (type: "TODAY_1000" | "WEEKLY_100") => {
    try {
      const res = await issueCouponMutation({ variables: { type } });
      const success = res.data?.issueFirstPurchaseCoupon?.success;

      if (success) {
        // 발급 성공 시 이벤트 종료 처리 (Seen 처리와 동일한 효과)
        markAsSeen();
        // 필요하다면 유저 정보를 refetch하여 쿠폰 목록 갱신 등을 유도할 수 있음
      }

      return success;
    } catch (e) {
      console.error("Failed to issue coupon:", e);
      return false;
    }
  };

  const eventStatus = data?.me?.firstPurchaseEventStatus;

  return {
    // 서버 응답이 있고, 대상자이며, 로컬에서도 본 적이 없어야 함
    isEligible: eventStatus?.isEligible && !hasSeenLocal,
    remainingDays: eventStatus?.remainingDays,
    loading,
    isIssuing,
    markAsSeen,
    issueCoupon,
    refetch,
  };
};
